import React, { createContext, useState } from 'react';

import { noop } from 'lodash-es';

import { type ModalComponentsType } from '@/components/ui/modals/ModalRoot';
import { type SetState } from '@/interfaces/common';
import { type ParentWithStudents } from '@/interfaces/parent';

export interface ContextValues {
  isLoggedIn: boolean;
  setIsLoggedIn: SetState<boolean>;
  currentUser: ParentWithStudents | null;
  setCurrentUser: SetState<ParentWithStudents | null>;
  toastMessage: string;
  setToastMessage: SetState<string>;
  isModalOpen: boolean;
  setIsModalOpen: SetState<boolean>;
  modalType: keyof ModalComponentsType | null;
  setModalType: SetState<keyof ModalComponentsType | null>;
  modalProps: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  setModalProps: SetState<any>; // eslint-disable-line @typescript-eslint/no-explicit-any
}

export const defaultValues: ContextValues = {
  isLoggedIn: false,
  setIsLoggedIn: noop,
  currentUser: null,
  setCurrentUser: noop,
  toastMessage: '',
  setToastMessage: noop,
  isModalOpen: false,
  setIsModalOpen: noop,
  modalType: null,
  setModalType: noop,
  modalProps: null,
  setModalProps: noop,
};

interface OwnProps {
  customValues?: Partial<ContextValues>;
  children?: React.ReactNode;
}

export const AppContext = createContext(defaultValues);

const ContextProvider: React.FC<OwnProps> = ({ children, customValues }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(defaultValues.isLoggedIn);
  const [currentUser, setCurrentUser] = useState(defaultValues.currentUser);
  const [toastMessage, setToastMessage] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(defaultValues.isModalOpen);
  const [modalType, setModalType] = useState(defaultValues.modalType);
  const [modalProps, setModalProps] = useState(defaultValues.modalProps);

  const values: ContextValues = {
    isLoggedIn,
    setIsLoggedIn,
    currentUser,
    setCurrentUser,
    toastMessage,
    setToastMessage,
    isModalOpen,
    setIsModalOpen,
    modalType,
    setModalType,
    modalProps,
    setModalProps,
    ...customValues,
  };

  return <AppContext.Provider value={values}>{children}</AppContext.Provider>;
};

export default ContextProvider;
